module.exports = __webpack_public_path__ + "static/media/bg.4a872808.webp";